//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { exportFile } from "quasar";
import { mapState } from "vuex";
import { date } from "quasar";

import numericclean from "@/components/numericClean";
import logger from "@/utils/logger";
import router from "../../router";

function wrapCsvValue(val, formatFn) {
  let formatted = formatFn !== void 0 ? formatFn(val) : val;
  formatted =
    formatted === void 0 || formatted === null ? "" : String(formatted);
  formatted = formatted.split('"').join('""');
  /**
   * Excel accepts \n and \r in strings, but some other CSV parsers do not
   * Uncomment the next two lines to escape new lines
   */
  // .split('\n').join('\\n')
  // .split('\r').join('\\r')
  return `"${formatted}"`;
}

export default {
  components: {
    numericclean,
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 15, // current rows per page being displayed
      },
      quantityAdjustedNumerics: [],
      stocks: [],
      Warehouses: [],
      Locations: [],
      includeEmptyLocations: false,
      countingStocks: [],
      counting: {},
      countingDate: null,
      headerTitle: "",
      stockLinesPost: [],
      disable: false,
      confirmComplete: false,
      confirmDelete: false,
      disableComplete: true,
      filter: "",
      dense: true,

      columns: [
        {
          name: "productNumber",
          align: "left",
          label: "Produktnummer",
          field: "productNumber",
          style: "width: 300px",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Produktnavn",
          field: "productName",

          sortable: true,
        },

        {
          name: "warehouseId",
          align: "left",
          label: "Lager",
          field: "warehouseName",
          sortable: true,
        },
        {
          name: "locationId",
          align: "left",
          label: "Lokasjon",
          field: "locationName",
          sortable: true,
        },
        {
          name: "pickedBy",
          align: "left",
          label: "Telt av",
          field: "pickedBy",
          sortable: true,
        },

        {
          name: "quantity",
          align: "left",
          label: "Antall",
          style: "width: 200px",
          field: "quantity",
          sortable: true,
        },
        {
          name: "quantityAdjusted",
          align: "left",
          style: "width: 200px",
          label: "Antall telt",
          field: "quantityAdjusted",
          sortable: true,
        },
      ],
    };
  },

  computed: {
    ...mapState("main", ["warehouses", "locations"]),
  },

  watch: {
    includeEmptyLocations(newValue, oldValue) {
      if (newValue != oldValue) {
        this.refresh();
      }
    },
  },

  methods: {
    focusNext(rowIndex) {
      const refName = 'quantityAdjusted' + (rowIndex + 1);
      const nextElement = this.$refs[refName];
      if (nextElement && nextElement.$el) { 
        nextElement.$el.focus();   
      }    
    },
    exportTable() {
      // naive encoding to csv format

      var content = [
        this.columns.map((col) => wrapCsvValue(col.label)).join(";"),
      ]
        .concat(
          this.stocks.map((row) =>
            this.columns
              .map((col) => {
                if (col.field === "warehouseId") {
                  col.field = "warehouseName";
                }
                if (col.field === "locationId") {
                  col.field = "locationName";
                }
                return wrapCsvValue(
                  typeof col.field === "function"
                    ? col.field(row)
                    : row[col.field === void 0 ? col.name : col.field],
                  col.format
                );
              })
              .join(";")
          )
        )
        .join("\r\n");
      var BOM = "\uFEFF";
      content = BOM + content;
      const status = exportFile("table-export.csv", content, "text/csv");
      if (status !== true) {
        this.$q.notify({
          message: "Browser denied file download...",
          color: "negative",
          icon: "warning",
        });
      }
    },
    completePopup() {
      if (!this.disableComplete) this.confirmComplete = true;
    },
    setAllQuantity() {
      this.stocks.forEach((element) => {
        if (!element.quantityAdjusted) {
          var cs = {};
          cs["countingId"] = parseInt(this.id);
          cs["stockId"] = element.id;
          cs["quantity"] = element.quantity;
          element.quantityAdjusted = element.quantity;
          this.stockLinesPost.push(cs);
          //hack to update ui. must fix
          this.pagination.rowsPerPage = this.pagination.rowsPerPage + 1;
          this.pagination.rowsPerPage--;
        }
      });
      const filteredStocks = this.stocks.filter((x) =>
        this.isNumeric(x.quantityAdjusted)
      );
 
      if (this.countingStocks.length == filteredStocks.length) {
        this.disableComplete = false;
      }
    },

    async fetchStock(id) {
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Henter linjer...",
      });

      const stocksFromApi = await this.getStocks({includeEmptyStock: this.includeEmptyLocations});
      this.countingStocks = await this.getCountingStocksByCountingId({id: id, includeEmptyLocations: this.includeEmptyLocations});
      
      this.counting = await this.getCounting(id);
      if (this.counting.countingDate) {
        this.countingDate = date.formatDate(
          this.counting.countingDate,
          "DD-MM-YYYY"
        );
      } else {
        this.countingDate = date.formatDate(Date.now(), "DD-MM-YYYY");
      }
      this.headerTitle = id.toString() + " - " + this.counting.name;

      this.stocks = [];
      const stocksCounted = [];
      this.countingStocks.forEach((countingStock) => {
        stocksFromApi.forEach((stock) => {
          if (stock.id == countingStock.stockId) {
            if (this.isNumeric(countingStock.quantity)) {
              stock.quantityAdjusted = countingStock.quantity;
              stock.pickedBy = countingStock.countedByName;
              stocksCounted.push(stock);
            }
            this.stocks.push(stock);
          }
        });
      });
      if (this.counting.completed || this.counting.canceled) {
        this.disable = true;
      }
      this.stocks.sort(function(a, b) {
        return a.productId - b.productId;
      });
      
      if (this.countingStocks.length == stocksCounted.length) {
        this.disableComplete = false;
      }
      this.disableComplete = false;
      setTimeout(() => {
        notif();
      }, 1000);
    },

    async refresh() {
      this.fetchStock(this.id, this.includeEmptyLocations);
    },

    async newStock() {
      const data = await this.getStocks();
      this.stocks = data;
    },
    isNumeric(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    postRow(row) {

      if (this.stockLinesPost.length > 0) {
        const index = this.stockLinesPost.findIndex(
          (x) => x.stockId === row.id
        );
        if (index > -1) {
          this.stockLinesPost.splice(index, 1);
        }
      }

      var cs = {};
      cs["countingId"] = parseInt(this.id);
      cs["stockId"] = row.id;
      if (this.isNumeric(row.quantityAdjusted))
        cs["quantity"] = row.quantityAdjusted;
      else cs["quantity"] = null;
      this.stockLinesPost.push(cs);

      //hack to update ui. must fix
      this.pagination.rowsPerPage = this.pagination.rowsPerPage + 1;
      this.pagination.rowsPerPage--;

      const filteredStocks = this.stocks.filter((x) =>
        this.isNumeric(x.quantityAdjusted)
      );
   
      if (this.countingStocks.length == filteredStocks.length) {
        this.disableComplete = false;
      } else {
        this.disableComplete = true;
      }
    },
    async completeCounting() {
      try {
        const notif = this.$q.notify({
          message: "Lagrer telling",
          timeout: 0,
          spinner: true,
        });
        await this.updateCounting();

        if (this.stockLinesPost.length > 0) {
          await this.postCountingStocks(this.stockLinesPost);
        }
        await this.postCountingComplete(this.id);
        this.stockLinesPost = [];
        this.disable = true;
        notif();
        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk"),
        });
      } catch (error) {
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
    },

    async updateCounting() {
      var putCountingDate = this.counting.countingDate;
      if (this.countingDate) {
        var tempDate = this.countingDate.split("-");
        putCountingDate = tempDate[2] + "-" + tempDate[1] + "-" + tempDate[0];
      }
      var putData = {
        id: this.counting.id,
        name: this.counting.name,
        countingDate: putCountingDate,
      };

      await this.putCounting(putData);
    },

    async saveCounting() {
      try {
      

        this.disable = true;

        await this.updateCounting();

        if (this.stockLinesPost.length > 0) {
          logger.log("Entering");
          logger.log(this.stockLinesPost);
          await this.postCountingStocks(this.stockLinesPost);
          this.stockLinesPost = [];
          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk"),
          });
        } else {
          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk"),
          });
        }
      } catch (error) {
        logger.log("error", error);
        this.disable = false;
        this.$q.notify({
          type: "negative",
          message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(error)}`,
        });
      }
      this.disable = false;
      this.refresh();
    },
    async delStock() {
      try {
        await this.postCountingCancel(this.id);

        this.$q.notify({
          type: "positive",
          message: this.$t("common.deleteMessage"),
        });
        router.push({
          name: "StockCountings",
        });
      } catch (error) {
        logger.log("error", error);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
    },

    async hideFromDate(pdate) {
      pdate.hide();
    },

    ...mapActions("main", [
      "getCountings",
      "getCounting",
      "getCountingStocksByCountingId",
      "getCountingStock",
      "getArticles",
      "getStocks",
      "putCounting",
      "postCountingStocks",
      "postCountingComplete",
      "postCountingCancel",
      "getStocksIncludeEmpty",
    ]),
  },
  created() {
    this.Warehouses = this.warehouses;
    this.Locations = this.locations;
    this.id = this.$route.params.id;
    this.fetchStock(this.id);
  },
};
